import React, { SFC } from 'react'

import Connection, { PublicProps as ConnectionProps } from './connection'
import { SignalRContext } from './connection-provider'

export const SignalRConnection: SFC<ConnectionProps> = ({ ...props }) => (
  <SignalRContext.Consumer>{(data) => <Connection {...props} connection={data.connection} />}</SignalRContext.Consumer>
)



// WEBPACK FOOTER //
// ./src/modules/signal-r/signal-r-connection.tsx